const BlockActionApiDefault = {
    action_type : {name : "api"},
    name : "API Call",
    type : { name : 'action'},
    data : {
        api_body_type : {id: 1, name: "x-www-form-urlencoded"},
        api_method_type :  {id: 2, name: "post"},
        body : [],
        headers : [],
        responses : [],
        url : ""
    }
}

const BlockActionApiServerDefault  = {
    name : "API Call",
    action_type : "api",
    api_body : [],
    api_body_type : "x-www-form-urlencoded",
    api_headers : [],
    api_method_type : "post",
    api_responses : [],
    api_url: ""
}

export { BlockActionApiDefault , BlockActionApiServerDefault }